import { __assign } from "tslib";
export function guessParams() {
    var _a = parse(location.search.replace(/^\??/, '')), instance = _a.instance, pageId = _a.pageId, compId = _a.compId;
    var _b = parseInstance(instance), metaSiteId = _b.metaSiteId, appDefId = _b.appDefId;
    if (metaSiteId && appDefId && pageId && compId && instance) {
        return {
            metaSiteId: metaSiteId,
            appDefId: appDefId,
            pageId: pageId,
            compId: compId,
            instance: instance,
        };
    }
}
function parse(query) {
    return query
        .split('&')
        .map(function (kvp) { return kvp.split('='); })
        .reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
}
function parseInstance(instance) {
    if (!instance) {
        return {};
    }
    try {
        return JSON.parse(atob(instance.split('.')[1]));
    }
    catch (e) {
        console.error('Could not parse instance', instance);
        return {};
    }
}
//# sourceMappingURL=guessParams.js.map